document.addEventListener('DOMContentLoaded', () => {
	const block = document.querySelector('.block--gallery');

	if (block) {
		const gallery = block.querySelector('.block--gallery__gallery');

		// eslint-disable-next-line no-undef
		imagesLoaded(gallery, () => {
			// eslint-disable-next-line no-unused-vars
			const masonry = new Masonry(gallery, {
				itemSelector: '.gallery-item',
				gutter: 16,
			});
		});
	}
});
